import { useEffect, useState } from "react";

export const useIsIOS = () => {
  const [isIOS, setIsIOS] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const checkIsIOS = () => {
      // Check if we're in a browser environment
      if (typeof window === "undefined") {
        return false;
      }

      // Check for PWA installation on iOS
      const isPWAShell = navigator.userAgent.includes("PWAShell");
      const cookies = document.cookie.split(";");
      const appPlatformCookie = cookies.find((cookie) => cookie.trim().startsWith("app-platform="));
      const isIOSAppStore = appPlatformCookie?.split("=")[1] === "iOS App Store";

      return isPWAShell || isIOSAppStore;
    };

    const result = checkIsIOS();
    setIsIOS(result);
  }, []);

  return isIOS;
};
